import React from 'react';
import {connect} from 'react-redux';
import {fetchUser} from '../../../../../actions/entities/user';
import {getEndpoint, getHeaders} from '../../../../../helpers/endpoint';
import {copyTextToClipboard} from '../../../../../helpers/utils';
import TableRow from '../../../components/TableRow';
import SupportTitle from '../../../components/title';
import {UserInfoStyles} from './styles';

const setAvatarToDefault = payload => {
  return (dispatch, getState) => {
    fetch(getEndpoint('setAvatarToDefault', payload.userId), {
      method: 'PATCH',
      headers: getHeaders(getState().authentication),
      body: JSON.stringify({lockAvatarUrl: Boolean(payload.lockAvatarUrl)}),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) {
        } else {
          dispatch(fetchUser({identifier: payload.userId}));
        }
      });
  };
};

const UserInfo = ({user, applicationsData, dispatch}) => {
  const avatarAction = (
    <div style={UserInfoStyles.avatarActionsContainer}>
      <button
        className="btn btn-warning"
        onClick={() =>
          dispatch(
            setAvatarToDefault({
              userId: user.id,
              lockAvatarUrl: user.lockedAvatarUrl,
            }),
          )
        }>
        set to default
      </button>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
          marginLeft: 8,
        }}>
        <div>locked</div>
        <input
          style={{minWidth: 0}}
          type="checkbox"
          checked={user.lockedAvatarUrl}
          onChange={() =>
            dispatch(
              setAvatarToDefault({
                userId: user.id,
                lockAvatarUrl: Boolean(!user.lockedAvatarUrl),
              }),
            )
          }
        />
      </div>
    </div>
  );
  return (
    <div>
      <SupportTitle title="User Info" />
      <table className="table table-sm table-responsive table-striped">
        <thead>
          <tr>
            <th>Key</th>
            <th>Value</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <TableRow label="Username" value={user.username || '-'} />
          <TableRow
            label="Avatar"
            value={
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  flexDirection: 'column',
                }}>
                <img
                  style={{maxWidth: 100, marginBottom: 8}}
                  src={user.avatarUrl}
                  alt=""
                />
                <button
                  className="btn btn-info"
                  onClick={() => copyTextToClipboard(user.avatarUrl)}>
                  Copy url
                </button>
              </div>
            }
            action={avatarAction}
          />
          <TableRow label="FirstName" value={user.firstName} />
          <TableRow label="LastName" value={user.lastName || '-'} />
          <TableRow label="language" value={applicationsData?.language || ''} />
          <TableRow label="Email" value={user.email} />
          <TableRow label="Bounce" value={user.bounce} />
          <TableRow label="Calibre" value={applicationsData?.level || 0} />
          <TableRow
            label="Main Favorite club"
            value={
              applicationsData?.mainFavoriteClubId &&
              applicationsData?.favoritesClubsNamesById
                ? applicationsData?.favoritesClubsNamesById[
                    applicationsData?.mainFavoriteClubId
                  ]
                : '-'
            }
          />
          <TableRow
            label="Favorites clubs"
            value={
              applicationsData?.favoritesClubsIds &&
              applicationsData?.favoritesClubsNamesById
                ? applicationsData.favoritesClubsIds.map(
                    (clubId, index) =>
                      `${index !== 0 ? ' - ' : ''}${
                        applicationsData.favoritesClubsNamesById[clubId]
                      }`,
                  )
                : '-'
            }
          />
        </tbody>
      </table>
    </div>
  );
};

export default connect(
  () => ({}),
  dispatch => ({dispatch}),
)(UserInfo);



// WEBPACK FOOTER //
// ./src/pages/Support/User/components/Info/index.js